import { Divider, Flex, Space } from "antd"
import { getDelRequestMemberAPI, getNotOrderMemberAPI } from "api/hq"
import { DataGrid, FillButton, SchoolSearch } from "components/elements"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { SimpleModal } from "./SimpleModal"

export const RecessApplyModal = ({ open, onClose, record, branchIdx, branchName, schoolIdx, schoolName }) => {
  const [list, setList] = useState([])

  const fnGetList = async () => {
    try {
      const { data } = await getDelRequestMemberAPI(record?.BRANCH_IDX, record?.SCHOOL_IDX || 0, 0, record?.yyyymm)
      const { data_list } = data
      setList(data_list)
    } catch (err) {
      console.error(err)
    }
  }

  const columns = [
    {
      title: '번호',
      align: 'center',
      render: (text, record, idx) => list?.length - idx,
      onCell: (record, idx) => {
        if (record?.REFUND_FG > 0) return {className: 'table-background-red'}
      }
    }, 
    {
      title: '교육원명',
      align: 'center',
      dataIndex: 'SCHOOL_NAME',
      onCell: (record, idx) => {
        if (record?.REFUND_FG > 0) return {className: 'table-background-red'}
      }
    }, 
    {
      title: '회원아이디',
      align: 'center',
      dataIndex: 'MEMBER_ID',
      onCell: (record, idx) => {
        if (record?.REFUND_FG > 0) return {className: 'table-background-red'}
      }
        
    }, 
    {
      title: '회원명',
      align: 'center',
      dataIndex: 'MEMBER_NAME',
      render: (text, record) => `${text}(주문완료)`,
      onCell: (record, idx) => {
        if (record?.REFUND_FG > 0) return {className: 'table-background-red'}
      },
    }, 
  ]

  useEffect(() => {
    if(open) fnGetList()
  }, [open])

  return (
    <SimpleModal
      title={`${record?.BRANCH_NAME}${record?.SCHOOL_NAME ? ` ${record?.SCHOOL_NAME}` : ''} 휴회신청 회원`}
      width={'50%'}
      open={open}
      onClose={onClose}
      footer={
        <Flex justify='center'>
          <FillButton label="닫기" color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={onClose} />
        </Flex>
      }
    >
      (휴회신청 회원수 : {list?.length} 명)
      <Divider className="divider-small" />

      <DataGrid 
        data={list}
        columns={columns}
      />
    </SimpleModal>
  )
}